import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'plus',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-plus wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="M12.495 4c.279 0 .505.226.505.496V11h6.504c.274 0 .496.214.496.505v.99a.503.503 0 0 1-.496.505H13v6.504a.493.493 0 0 1-.505.496h-.99a.503.503 0 0 1-.505-.496V13H4.496A.493.493 0 0 1 4 12.495v-.99c0-.279.226-.505.496-.505H11V4.496c0-.274.214-.496.505-.496h.99z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-plus.svg',
    category: 'Core',
    tags: ['add', 'positive', 'new', 'start'],
};
export default icon;
